import type { PropsWithChildren } from "react";

import { cn, Tooltip as DSTooltip } from "@eisox/design-system";

interface TooltipProps extends PropsWithChildren {
  content: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  openingCondition?: boolean;
  keepHoverOpen?: boolean;
  className?: string;
  forceMount?: true;
  arrow?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  position = "bottom",
  sideOffset,
  openingCondition = true,
  keepHoverOpen = true,
  forceMount,
  arrow = true,
  className,
}) => (
  <DSTooltip.Provider delayDuration={0}>
    <DSTooltip.Root disableHoverableContent={!keepHoverOpen}>
      <DSTooltip.Trigger asChild>{children}</DSTooltip.Trigger>
      {content && openingCondition && (
        <DSTooltip.Portal forceMount={forceMount}>
          <DSTooltip.Content
            className={cn(
              "z-2000 max-h-[calc(var(--radix-tooltip-content-available-height)-20px)] overflow-y-auto text-base",
              className,
            )}
            side={position}
            sideOffset={sideOffset}
          >
            {content}
            {arrow && <DSTooltip.Arrow />}
          </DSTooltip.Content>
        </DSTooltip.Portal>
      )}
    </DSTooltip.Root>
  </DSTooltip.Provider>
);

Tooltip.displayName = "Tooltip";

export { Tooltip };
export type { TooltipProps };
